<div class="td-wb-number-spinner"
     [class.td-wb-number-spinner--error]="isError()"
     [class.td-wb-number-spinner--disabled]="isDisabled()"
     [class.td-wb-number-spinner--active]="isActive()">
    <span class="td-wb-number-spinner__wrap">
      <button class="td-wb-number-spinner__button td-wb-number-spinner__button--left"
              type="button"
              [attr.aria-label]="'tdWb.numberSpinner.BUTTON_DOWN_ARIA' | tdWbTranslate"
              (click)="onDecrement()">
        <td-wb-icon class="td-wb-number-spinner__icon"
                    size="12"
                    iconId="minus" />
      </button>
      <div class="td-wb-number-spinner__input-wrap">
        <ng-content select="[tdWbInput][type='number']" />
      </div>
      <button class="td-wb-number-spinner__button td-wb-number-spinner__button--right"
              type="button"
              [attr.aria-label]="'tdWb.numberSpinner.BUTTON_UP_ARIA' | tdWbTranslate"
              (click)="onIncrement()">
        <td-wb-icon class="td-wb-number-spinner__icon"
                    size="12"
                    iconId="plus" />
      </button>
    </span>
</div>
